export const API_URL = process.env.REACT_APP_API_URL;
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;

export const BASE_DATE_FORMAT = "DD MMM-YYYY HH:mm";

export const STRIPE_TOKEN = process.env.REACT_APP_STRIPE_TOKEN;
